(() => {
  const onThemePageLoad = () => {
    if (window.customElements && customElements.upgrade) {
      customElements.upgrade(document.body);
    }
  };

  if (!window.__cclp2StepSignupLocationsPageLoadHook) {
    window.__cclp2StepSignupLocationsPageLoadHook = true;
    document.addEventListener('theme:page:load', onThemePageLoad);
  }

  if (customElements.get('cclp-2step-signup-loc')) return;

  const KLAVIYO_ENDPOINT = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const tzOffset = () => -(new Date().getTimezoneOffset() / 60);

  const setSubscribedCookie = () => {
    try {
      const d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie = `SUBSCRIBED=1;expires=${d.toUTCString()};path=/`;
    } catch (e) {}
  };

  const postKlaviyo = (listId, email, source, locations) => {
    const fields = ['$consent', '$source'];
    const params = {
      email,
      g: listId,
      $consent: 'email',
      $list_fields: '$consent',
      $source: source || 'cclp-2step-signup-locations',
      $timezone_offset: String(tzOffset()),
    };
    if (locations) {
      params.preferred_locations = locations;
      fields.push('preferred_locations');
    }
    params.$fields = fields.join(',');
    const body = new URLSearchParams(params);
    return fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
      body: body.toString(),
    });
  };

  class Cclp2StepSignupLoc extends HTMLElement {
    connectedCallback() {
      this.panels = {
        1: this.querySelector('.cclp-2step-signup__step[data-panel="1"]'),
        2: this.querySelector('.cclp-2step-signup__step[data-panel="2"]'),
        success: this.querySelector('.cclp-2step-signup__step[data-panel="success"]'),
      };
      this.indicator = this.querySelector('[data-step-indicator]');
      this.emailForm = this.querySelector('[data-form="email"]');
      this.smsForm = this.querySelector('[data-form="sms"]');
      this.skipBtn = this.querySelector('[data-action="skip-sms"]');

      if (this.emailForm) this.emailForm.addEventListener('submit', this._onEmailSubmit);
      if (this.smsForm) this.smsForm.addEventListener('submit', this._onSmsSubmit);
      if (this.skipBtn) this.skipBtn.addEventListener('click', this._onSkip);

      this._setupLocations();
    }

    disconnectedCallback() {
      if (this.emailForm) this.emailForm.removeEventListener('submit', this._onEmailSubmit);
      if (this.smsForm) this.smsForm.removeEventListener('submit', this._onSmsSubmit);
      if (this.skipBtn) this.skipBtn.removeEventListener('click', this._onSkip);
      if (this.locToggle) this.locToggle.removeEventListener('click', this._onLocToggleClick);
      if (this.locPanel) this.locPanel.removeEventListener('change', this._onLocPanelChange);
      if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
    }

    showStep(name) {
      Object.keys(this.panels).forEach((key) => {
        const el = this.panels[key];
        if (!el) return;
        if (key === String(name)) {
          el.hidden = false;
          requestAnimationFrame(() => {
            el.style.opacity = '1';
          });
        } else {
          el.style.opacity = '0';
          el.hidden = true;
        }
      });

      if (this.indicator) {
        const currentBarStep = name === 'success' ? 2 : Number(name);
        this.indicator.querySelectorAll('[data-bar]').forEach((bar) => {
          if (Number(bar.dataset.bar) <= currentBarStep) {
            bar.setAttribute('aria-current', 'true');
          } else {
            bar.removeAttribute('aria-current');
          }
        });
        this.indicator.querySelectorAll('[data-step]').forEach((label) => {
          if (label.dataset.step === String(name)) {
            label.setAttribute('aria-current', 'true');
          } else {
            label.removeAttribute('aria-current');
          }
        });
      }

      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }

    _onEmailSubmit = (e) => {
      e.preventDefault();
      const input = this.emailForm.querySelector('input[name="email"]');
      const err = this.emailForm.querySelector('[data-error="email"]');
      const email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        err.dataset.visible = 'true';
        input.focus();
        return;
      }
      err.dataset.visible = 'false';

      const listId = this.dataset.klaviyoListId;
      const source = this.dataset.klaviyoSource;
      const locations = this._gatherLocations();
      this.dataset.capturedEmail = email;
      if (locations) this.dataset.capturedLocations = locations;

      this.showStep(2);

      if (listId) {
        postKlaviyo(listId, email, source, locations)
          .then((res) => {
            if (res.ok) setSubscribedCookie();
          })
          .catch((err) => {
            if (window.console?.warn) console.warn('[cclp-2step-signup-loc] Klaviyo subscribe failed', err);
          });
      }
    };

    _onSmsSubmit = (e) => {
      const input = this.smsForm.querySelector('input[name="phone"]');
      const err = this.smsForm.querySelector('[data-error="phone"]');
      const phone = (input.value || '').replace(/\D/g, '');
      if (phone.length < 10) {
        e.preventDefault();
        err.dataset.visible = 'true';
        input.focus();
        return;
      }
      err.dataset.visible = 'false';
      setTimeout(() => {
        this.showStep('success');
      }, 80);
    };

    _onSkip = () => {
      this.showStep('success');
    };

    _setupLocations() {
      this.locWrap = this.querySelector('[data-locations]');
      if (!this.locWrap) return;
      this.locToggle = this.locWrap.querySelector('[data-loc-toggle]');
      this.locPanel = this.locWrap.querySelector('[data-loc-panel]');
      this.locPlaceholder = this.locWrap.querySelector('[data-loc-placeholder]');
      this.locChips = this.locWrap.querySelector('[data-loc-chips]');
      this.locInputs = [...this.locWrap.querySelectorAll('[data-loc-input]')];

      this._onLocToggleClick = () => {
        this._toggleLocPanel();
      };
      this._onLocPanelChange = (e) => {
        if (e.target?.hasAttribute('data-loc-input')) this._onLocChange(e.target);
      };
      this._onDocClick = (e) => {
        if (this.locWrap && !this.locWrap.contains(e.target)) this._closeLocPanel();
      };

      this.locToggle.addEventListener('click', this._onLocToggleClick);
      this.locPanel.addEventListener('change', this._onLocPanelChange);
      document.addEventListener('click', this._onDocClick);
    }

    _toggleLocPanel() {
      if (this.locWrap.hasAttribute('data-open')) {
        this._closeLocPanel();
      } else {
        this.locWrap.setAttribute('data-open', '');
        this.locPanel.hidden = false;
        this.locToggle.setAttribute('aria-expanded', 'true');
      }
    }

    _closeLocPanel() {
      this.locWrap.removeAttribute('data-open');
      this.locPanel.hidden = true;
      this.locToggle.setAttribute('aria-expanded', 'false');
    }

    _onLocChange(input) {
      const isAll = input.hasAttribute('data-loc-all');
      if (input.checked) {
        if (isAll) {
          this.locInputs.forEach((i) => {
            if (i !== input) i.checked = false;
          });
        } else {
          this.locInputs.forEach((i) => {
            if (i.hasAttribute('data-loc-all')) i.checked = false;
          });
        }
      }
      this._renderLocChips();
    }

    _renderLocChips() {
      this.locChips.innerHTML = '';
      let any = false;
      this.locInputs.forEach((input) => {
        if (!input.checked) return;
        any = true;
        const nameEl = input.parentNode.querySelector('.cclp-2step-signup__loc-name');
        const text = nameEl ? nameEl.textContent : input.value;
        const chip = document.createElement('span');
        chip.className = 'cclp-2step-signup__loc-chip';
        chip.appendChild(document.createTextNode(text));
        const x = document.createElement('button');
        x.type = 'button';
        x.textContent = '×';
        x.setAttribute('aria-label', `Remove ${text}`);
        x.addEventListener('click', (e) => {
          e.stopPropagation();
          input.checked = false;
          this._renderLocChips();
        });
        chip.appendChild(x);
        this.locChips.appendChild(chip);
      });
      this.locPlaceholder.style.display = any ? 'none' : '';
    }

    _gatherLocations() {
      if (!this.locInputs) return '';
      return this.locInputs
        .filter((i) => i.checked)
        .map((i) => i.value)
        .join(',');
    }
  }

  customElements.define('cclp-2step-signup-loc', Cclp2StepSignupLoc);
})();
